export default class Share {
  constructor({
    action, link, desc, title, img, mp,
    cb, success, bizChannel, taskId
  } = { success: function() {}, cb: function() {} }) {
    if (action === 'wechat') {
      this.link = link ? link : location.href;
      this.desc = desc;
    } else {
      this.action = action;
      this.content = desc;
      this.shareUrl = link ? link : location.href;
      this.miniProgramData = mp
    }
    this.success = success
    this.title = title;
    this.imgUrl = img;
    this.lazyDataCb = cb
    if (bizChannel) this.bizChannel = bizChannel
    if (taskId) this.taskId = taskId
  }
}